<template>
	<div class="page" id="default-page">
		<!-- 默认页、登录、联系页布局 -->
		<div class="page-header">
			<div class="logo" @click="goHome">
				<img src="@/assets/images/logo@2x.png" alt="" />
			</div>
			<div class="tools">
				<a-button
					v-if="activeIndex == 1"
					type="primary"
					@click="goLogin"
				>
					免费体验
				</a-button>
				<div v-if="activeIndex == 2" class="back" @click="back">
					<img src="@/assets/images/home@2x.png" alt="" />
					首页
				</div>
			</div>
		</div>
		<div class="page-content">
			<div class="inner-box">
				<router-view></router-view>
			</div>
		</div>

		<div class="copyright" @click="goCompanyHome">
			<img src="@/assets/images/foot@2x.png" alt="" />
		</div>
	</div>
</template>

<script setup>
	import { ref, watch } from "vue";
	import { useRouter } from "vue-router";
	import { goCompanyHome } from "../plugins/index.js";
	const router = useRouter();

	const activeIndex = ref(1);

	watch(
		() => router.currentRoute.value.path,
		() => {
			//要执行的方法
			const routeInfo = router.currentRoute.value;
			if (routeInfo.name == "exhibition") activeIndex.value = 1;
			if (routeInfo.name == "login" || routeInfo.name == "concat")
				activeIndex.value = 2;
		},
		{ immediate: true, deep: true }
	);

	const back = () => {
		// router.go(-1);
		router.push("/");
	};

	const goLogin = () => {
		router.push("/login");
	};

	const goHome = () => {
		// router.push("/");
	};
</script>

<style lang="less">
	.page {
		width: 100%;
		height: 100vh;
		overflow-y: hidden;
		position: relative;
		background-color: #eef2f5;

		&-header {
			height: 56px;
			background: #ffffff;
			border: 1px solid #00000014;
			position: relative;

			.logo {
				position: absolute;
				left: 32px;
				bottom: 8px;
				cursor: pointer;
				img {
					width: 148px;
					height: 40px;
				}
			}

			.tools {
				position: absolute;
				right: 32px;
				top: 50%;
				transform: translateY(-50%);

				.ant-btn {
					width: 120px;
					height: 40px;
					background: #0058fc;
					border-radius: 4px;

					font-family: PingFangSC-Medium;
					font-weight: 500;
					font-size: 16px;
					color: #ffffff;
					letter-spacing: 0;
				}

				.back {
					display: flex;
					align-items: center;
					opacity: 0.85;
					font-family: PingFangSC-Medium;
					font-weight: 600;
					font-size: 16px;
					color: #000000;
					letter-spacing: 0;
					text-align: right;
					cursor: pointer;

					img {
						width: 24px;
						height: 24px;
						margin-right: 8px;

						&:hover {
							background-color: #a2abbb29;
							border-radius: 4.67px;
						}
					}
				}
			}
		}

		&-content {
			position: relative;
			background-image: url(../assets/images/background@2x.png);
			background-repeat: no-repeat;
			background-size: 100% auto;
			background-position: 50%;
			width: 100%;
			max-width: 1920px;
			height: calc(100% - 56px);
			margin: 0 auto;
			overflow: hidden;

			.inner-box {
				width: 55%;
				height: 100%;
				position: absolute;
				top: 0;
				right: 0;
				background-image: linear-gradient(
					270deg,
					#eef1f5 0%,
					#eef1f5 57%,
					#edf2f400 100%
				);

				.box {
					position: absolute;
					top: 45%;
					left: 17.86vw;
					transform: translateY(-50%);
					width: 376px;
					height: 458px;
					background: #ffffff;
					box-shadow: 0 8px 16px 8px #6876860a;
					border-radius: 8px;
					padding: 58px 48px 32px 48px;
					.logo {
						text-align: center;
						img {
							width: 177.6px;
							height: 48px;
						}
					}
				}

				.footer {
					height: 24px;
					font-family: PingFangSC-Regular;
					font-weight: 500;
					font-size: 16px;
					color: #0058fc;
					letter-spacing: 0;
					text-align: center;
					line-height: 24px;
					position: absolute;
					bottom: 24px;
					left: 50%;
					transform: translateX(-50%);
					cursor: pointer;
				}
			}
		}

		.copyright {
			position: absolute;
			bottom: 16px;
			left: 50%;
			transform: translateX(-50%);
			cursor: pointer;
			img {
				width: 385px;
				height: 24px;
			}
		}
	}
</style>
